import { ActionType, createAsyncAction } from 'typesafe-actions';

import { GetPromotionsPermissionsResponse } from '../../../../common/all/api/gen/CampaignDeliveryProvider';

export const requestPromotionsPermissionAsyncAction = createAsyncAction(
  '@promotionsPermissions/GET_PROMOTIONS_PERMISSION_REQUEST',
  '@promotionsPermissions/GET_PROMOTIONS_PERMISSION_SUCCESS',
  '@promotionsPermissions/GET_PROMOTIONS_PERMISSION_FAILURE',
)<void, GetPromotionsPermissionsResponse, Error>();

export type PromotionsPermissionsAction = ActionType<typeof requestPromotionsPermissionAsyncAction>;
